export default "/anything.c227277657c934fa95e236cc0d7ddae0.png";